export const SUPPORT_WHATSAPP_E164 = '5511935354685';
export const SUPPORT_WHATSAPP_DISPLAY = '(11) 93535-4685';

export const SUPPORT_DIALOG = {
  component: 'DialogSupport',
  maxWidth: '520px',
} as const;

export function buildSupportWhatsappMessage({ companySlug, email }: {
  companySlug: string;
  email: string;
}) {
  return `Olá, preciso de suporte com o app.zazos.com. Empresa: ${companySlug}, email: ${email}`;
}

export function buildSupportWhatsappUrl({ companySlug, email }: {
  companySlug: string;
  email: string;
}) {
  return `https://wa.me/${SUPPORT_WHATSAPP_E164}?text=${encodeURIComponent(buildSupportWhatsappMessage({ companySlug, email }))}`;
}
